import { inject, Service, service } from './di'
import { AccountsService } from './AccountsService'
import { AuthStatus } from './definitions/IAuthenticationService'
import { AuthenticationService } from './AuthenticationService'
import { AnalyticsService } from './AnalyticsService'
import { LocationService } from './LocationService'
import { ConfigService } from './ConfigService'
import { EventService } from './EventService'
import { NOT_SELL_DATA_POPUP_TAG_ELEMENT_ID } from '../components/flipp-info-popup/InfoPopup'

@service('gpcService')
export class GPCService extends Service {
    @inject auth: AuthenticationService
    @inject accounts: AccountsService
    @inject analytics: AnalyticsService
    @inject location: LocationService
    @inject config: ConfigService
    @inject eventService: EventService

    init() {
        const gpcCookie = Cookies.getJSON('flipp-gpc')
        const gpcEnabled = (window.navigator as any).globalPrivacyControl
        if (gpcCookie && !gpcEnabled) {
            Cookies.remove('flipp-gpc', {
                domain:
                    this.config.ENV === 'development'
                        ? 'localhost'
                        : '.flipp.com',
            })
            return
        }
        const emailsFromCookie = gpcCookie && gpcCookie['emails']
        const email =
            this.auth &&
            this.auth.status === AuthStatus.LOGGED_IN &&
            this.auth.user.info.email
        if (
            email &&
            gpcEnabled &&
            (!emailsFromCookie ||
                (emailsFromCookie && !emailsFromCookie.includes(email)))
        ) {
            const appVersionArray = this.config.BUILD.split('/')
            const countryCodeArray = this.location.locale.split('-')
            this.accounts
                .notSellData({
                    user_id: this.auth.user.token['user_id'],
                    access_token: this.auth.user.token['access_token'],
                    email: this.auth.user.info.email,
                    residentOf: '',
                    sid: this.analytics.sessionId,
                    fsa: this.location.postalCode,
                    locale: this.location.locale,
                    platform: 'flipp_web',
                    application_version:
                        appVersionArray[appVersionArray.length - 1],
                    country_code:
                        countryCodeArray[
                            countryCodeArray.length - 1
                        ].toUpperCase(),
                })
                .then(() => {
                    this.eventService.displayInfoPopup(
                        NOT_SELL_DATA_POPUP_TAG_ELEMENT_ID
                    )

                    const emails = emailsFromCookie ? emailsFromCookie : []
                    emails.push(email)
                    Cookies.set('flipp-gpc', JSON.stringify({ emails }), {
                        expires: 30 * 12, // one year
                        domain:
                            this.config.ENV === 'development'
                                ? 'localhost'
                                : '.flipp.com',
                    })
                })
        }
    }
}
